import type {Page} from '@/types';

import {lazy, Suspense, useMemo} from 'react';

import {LayerPortal} from '@/components/LayerPortal';
import {useOmnichannelChat} from '@/modules/common/context/OmnichannelChat';
import {useLocalSplit} from '@/modules/common/hooks';
import {useCurrentPage} from '@/modules/common/hooks/useCurrentPage';

const OmnichannelChatWidget = lazy(
  () => import('@travel-frontend/omnichannel-chat-widget/widget')
);

const widgetSourceByPage: Record<Page, string> = {
  hotels: 'Hotelliste',
  offers: 'Angebotliste',
};

export const OmnichannelChat = () => {
  const currentPage = useCurrentPage();
  const enabled =
    useLocalSplit('FFP_5811_omnichannel_livechat').treatment === 'on';
  const [, setOmnichannelChat] = useOmnichannelChat();

  const customContext = useMemo(
    () => ({
      // variables names are passed through "as is", so these names are what the service center agent sees
      Herkunft: {
        isDisplayable: true,
        Value: widgetSourceByPage[currentPage],
      },
      Url: {
        isDisplayable: true,
        Value: window.location.href,
      },
    }),
    [currentPage]
  );

  const chatButtonOffset = useMemo(
    () => ({
      top: null,
      left: null,
      right: 22,
      bottom: 76,
    }),
    []
  );

  if (!enabled) {
    return null;
  }

  return (
    <LayerPortal>
      <Suspense>
        <OmnichannelChatWidget
          orgId={import.meta.env.VITE_OMNICHANNEL_ORG_ID}
          orgUrl={import.meta.env.VITE_OMNICHANNEL_ORG_URL}
          widgetId={import.meta.env.VITE_OMNICHANNEL_WIDGET_ID}
          zIndex={3}
          customContext={customContext}
          chatButtonOffset={chatButtonOffset}
          onInit={setOmnichannelChat}
        />
      </Suspense>
    </LayerPortal>
  );
};
